var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip-text",class:{'tooltip-text--top' : _vm.position === 'top',
                     'tooltip-text--bottom' : _vm.position === 'bottom',
                     'tooltip-text--bottom-left' : _vm.position === 'bottom-left',
                     'tooltip-text--bottom-right' : _vm.position === 'bottom-right',
                     'tooltip-text--right' : _vm.position === 'right',
                     'tooltip-text--left' : _vm.position === 'left',
                     'tooltip-visible' : _vm.visible}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }